<template>
    <section class="container-fluid header-list-type-2">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="wrp">
                        <div class="content">
                            <h1 class="name">{{ account.name || '-' }}<div class="indicator" :class="account.status ? 'active' : 'inactive'"></div></h1>
                            <p>{{ account.url || '-' }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from 'pinia';
    import { useAccountStore } from '@/stores/account';

    export default {
        name: "DashboardHeader",
        computed: {
            ...mapState(useAccountStore, ['account']),
        }
    }
</script>